import {
  AudienceFieldType,
  AudienceMatchType,
  AudienceOpType,
} from "@/types/graphql/partner.generated";

export const AUDIENCE_MATCH_KEYS: Record<AudienceMatchType, string> = {
  [AudienceMatchType.AllType]: "broadcasts.audience.matchALL",
  [AudienceMatchType.AnyType]: "broadcasts.audience.matchANY",
};

export const AUDIENCE_FIELD_KEYS: Record<AudienceFieldType, string> = {
  [AudienceFieldType.HasPurchasesType]:
    "broadcasts.audience.field.HAS_PURCHASES",
  [AudienceFieldType.PurchasedProductType]:
    "broadcasts.audience.field.PURCHASED_PRODUCT",
  [AudienceFieldType.SpentUsdType]: "broadcasts.audience.field.SPENT_USD",
  [AudienceFieldType.HasActiveSubscriptionType]:
    "broadcasts.audience.field.HAS_ACTIVE_SUBSCRIPTION",
  [AudienceFieldType.LastViewDaysAgoType]:
    "broadcasts.audience.field.LAST_VIEW_DAYS_AGO",
  [AudienceFieldType.RegisteredDaysAgoType]:
    "broadcasts.audience.field.REGISTERED_DAYS_AGO",
  [AudienceFieldType.CountryType]: "broadcasts.audience.field.COUNTRY",
  [AudienceFieldType.LanguageType]: "broadcasts.audience.field.LANGUAGE",
  [AudienceFieldType.RegistrationUtmSourceType]:
    "broadcasts.audience.field.REGISTRATION_UTM_SOURCE",
  [AudienceFieldType.RegistrationUtmCampaignType]:
    "broadcasts.audience.field.REGISTRATION_UTM_CAMPAIGN",
  [AudienceFieldType.RegistrationUtmMediumType]:
    "broadcasts.audience.field.REGISTRATION_UTM_MEDIUM",
  [AudienceFieldType.RegistrationLinkType]:
    "broadcasts.audience.field.REGISTRATION_LINK",
  [AudienceFieldType.RegistrationEmailCampaignType]:
    "broadcasts.audience.field.REGISTRATION_EMAIL_CAMPAIGN",
  [AudienceFieldType.EmailOpenedType]: "broadcasts.audience.field.EMAIL_OPENED",
  [AudienceFieldType.EmailClickedType]:
    "broadcasts.audience.field.EMAIL_CLICKED",
  [AudienceFieldType.UpcomingStreamType]:
    "broadcasts.audience.field.UPCOMING_STREAM",
};

const AUDIENCE_OP_KEYS: Record<AudienceOpType, string> = {
  [AudienceOpType.IsType]: "broadcasts.audience.op.IS",
  [AudienceOpType.InType]: "broadcasts.audience.op.IN",
  [AudienceOpType.NotInType]: "broadcasts.audience.op.NOT_IN",
  [AudienceOpType.GteType]: "broadcasts.audience.op.GTE",
  [AudienceOpType.LteType]: "broadcasts.audience.op.LTE",
  [AudienceOpType.NeverType]: "broadcasts.audience.op.NEVER",
};

// У «дней назад» общие «не меньше/не больше» читаются двусмысленно,
// поэтому у этих полей свои подписи операций.
const FIELD_OP_KEYS: Partial<
  Record<AudienceFieldType, Partial<Record<AudienceOpType, string>>>
> = {
  [AudienceFieldType.LastViewDaysAgoType]: {
    [AudienceOpType.GteType]: "broadcasts.audience.op.LAST_VIEW_GTE",
    [AudienceOpType.LteType]: "broadcasts.audience.op.LAST_VIEW_LTE",
  },
  [AudienceFieldType.RegisteredDaysAgoType]: {
    [AudienceOpType.GteType]: "broadcasts.audience.op.REGISTERED_GTE",
    [AudienceOpType.LteType]: "broadcasts.audience.op.REGISTERED_LTE",
  },
};

export const audienceOpKey = (
  field: AudienceFieldType,
  op: AudienceOpType
): string => FIELD_OP_KEYS[field]?.[op] ?? AUDIENCE_OP_KEYS[op];
